import { Directive, HostBinding, Input } from '@angular/core';

// taken from https://github.com/dkreider/ngx-loading-buttons
@Directive({
  selector: '[appLoadingButton]',
  standalone: true,
})
export class LoadingButtonDirective {
  @HostBinding('class.mat-spinner')
  loading = false;

  @HostBinding('attr.disabled')
  disabled: true | null = null;

  @Input() set appLoadingButton(loading: boolean) {
    this.loading = loading;
    this.disabled = loading || null;
  }
}
